import {get,postJson,post} from '@/api/request/CommonRequest'
import axios from 'axios'
import { Message, Modal } from 'view-design'
import qs from 'qs'

export let userMethod = {}

 

userMethod.getRepairUser = function () {
  return post('/user/getRepairUser')
}

userMethod.getStoresUser = function () {
  return post('/user/getStoresUser')
}
